<template>
    <div class="overlay" @touchmove.stop="move">
        <slot @close="$emit('close')"></slot>
        <button @click="$emit('close')" class="close">&times;</button>
    </div>
</template>

<script>
    export default {
        methods: {
            move()
            {
                return 1;
            }
        }
    };
</script>

<style>

</style>
